import styled from 'styled-components';

export const ProfissionalCardWrapper = styled.div`
  margin-bottom: 70px;

  .slick-slider {
    .slick-dots {
      @media (max-width: 768px) {
        bottom: -50px;
      }
    }
  }
`;
